
export const languages = [
    {
        id:1,
        name:'English',
        level:'B2 - C1',
    },
    {
        id:2,
        name:'Persian',
        level:'Native',
    },
]